import React from 'react'
import "./Footer.css"
const Footer = () => {
  return (
    <div className='footer'>
     © 2025 Pvalue Analytics · Version 1.0.0
      </div>
  )
}

export default Footer